module.exports = __webpack_public_path__ + "static/media/no_minute_4.e49fd0ab.jpg";